import { render, staticRenderFns } from "./ShippingMaster.vue?vue&type=template&id=50c91c8d&scoped=true&"
import script from "./ShippingMaster.vue?vue&type=script&lang=js&"
export * from "./ShippingMaster.vue?vue&type=script&lang=js&"
import style0 from "./ShippingMaster.vue?vue&type=style&index=0&id=50c91c8d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50c91c8d",
  null
  
)

export default component.exports